import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	projectIsAssociatedWithDefaultScheme: {
		id: 'admin-pages-priority-schemes.priority-scheme-modal.project-picker.project-picker-content.project-is-associated-with-default-scheme',
		defaultMessage:
			'Projects can’t be removed from the default scheme but they can be added to other schemes.',
		description:
			'Tooltip content to inform users they cannot remove a particular project from the default priority scheme because it is not associated with any other priority schemes.',
	},
	projectIsAssociatedWithScheme: {
		id: 'admin-pages-priority-schemes.priority-scheme-modal.project-picker.project-picker-content.project-is-associated-with-scheme',
		defaultMessage: 'This project is already associated with the scheme.',
		description:
			'Tooltip content to inform users a particular project is already associated with the current priority scheme.',
	},
	maxSelectionLimit: {
		id: 'admin-pages-priority-schemes.priority-scheme-modal.project-picker.project-picker-content.max-selection-limit',
		defaultMessage:
			'You’ve selected 100 projects. Save your changes or remove projects to select more.',
		description:
			'Tooltop content to inform users they have reached the maximum limit of projects they can edit in one operation for the current priority scheme',
	},
	noSearchResults: {
		id: 'admin-pages-priority-schemes.priority-scheme-modal.project-picker.project-picker-content.no-search-results',
		defaultMessage: 'We couldn’t find what you’re looking for. Try searching for another project.',
		description:
			'Information to display when there are no search results returned for a project the user is looking for.',
	},
	noProjectsInJira: {
		id: 'admin-pages-priority-schemes.priority-scheme-modal.project-picker.project-picker-content.no-projects-in-jira',
		defaultMessage: 'You don’t have any projects in this Jira instance. ',
		description: 'Information to display the user has no projects available in their Jira instance',
	},
	errorTitle: {
		id: 'admin-pages-priority-schemes.priority-scheme-modal.project-picker.project-picker-content.error-title',
		defaultMessage: 'We couldn’t load your projects',
		description: 'Error title when there is a problem with loading projects',
	},
	errorMessage: {
		id: 'admin-pages-priority-schemes.priority-scheme-modal.project-picker.project-picker-content.error-message',
		defaultMessage: 'Check your connection and try again.',
		description: 'Error message when there is a problem with loading projects',
	},
	retry: {
		id: 'admin-pages-priority-schemes.priority-scheme-modal.project-picker.project-picker-content.retry',
		defaultMessage: 'Try again',
		description: 'Button label for retrieving projects when there is an error',
	},
	selectAll: {
		id: 'admin-pages-priority-schemes.priority-scheme-modal.project-picker.project-picker-content.select-all',
		defaultMessage: 'Select all',
		description: 'Checkbox label to select all projects available on the page',
	},
	paginationNextLabel: {
		id: 'admin-pages-priority-schemes.priority-scheme-modal.project-picker.project-picker-content.pagination-next-label',
		defaultMessage: 'Next',
		description: 'Label for going to the next page in a list of paginated pages',
	},
	paginationPageLabel: {
		id: 'admin-pages-priority-schemes.priority-scheme-modal.project-picker.project-picker-content.pagination-page-label',
		defaultMessage: 'Page',
		description: 'Label for a page in a list of paginated pages',
	},
	paginationPreviousLabel: {
		id: 'admin-pages-priority-schemes.priority-scheme-modal.project-picker.project-picker-content.pagination-previous-label',
		defaultMessage: 'Previous',
		description: 'Label for going to the previous page in a list of paginated pages',
	},
	paginationSummary: {
		id: 'admin-pages-priority-schemes.priority-scheme-modal.project-picker.project-picker-content.pagination-summary',
		defaultMessage:
			'Showing {startRow} - {endRow} of {totalRows, plural, one {# project} other {# projects}}',
		description:
			'Summary of current rows being shown in the table. {startRow} and {endRow} is the limit of rows currently visible on the table (e.g. 1 to 10). {totalRows} is total count of projects available for this Jira instance (e.g. 100).',
	},
	createSchemeAllProjectsFilterInfo: {
		id: 'admin-pages-priority-schemes.priority-scheme-modal.project-picker.project-picker-content.create-scheme-all-projects-filter-info',
		defaultMessage:
			'View all projects in your Jira instance and select those you want to associate with the scheme',
		description:
			'Section message to inform users that the filter for all projects shows all projects available in their Jira instance when creating a priority scheme',
	},
	editSchemeAllProjectsFilterInfo: {
		id: 'admin-pages-priority-schemes.priority-scheme-modal.project-picker.project-picker-content.edit-scheme-all-projects-filter-info',
		defaultMessage:
			'View all projects in your Jira instance and select those you want to associate with the scheme "{schemeName}".',
		description:
			'Section message to inform users that the filter for all projects shows all projects available in their Jira instance when editing a priority scheme',
	},
	existingProjectsFilterInfo: {
		id: 'admin-pages-priority-schemes.priority-scheme-modal.project-picker.project-picker-content.existing-projects-filter-info',
		defaultMessage: 'View projects that are already associated with the scheme “{schemeName}”.',
		description:
			'Section message to inform users that the filter for existing projects shows projects which are already associated with the current priority scheme',
	},
	companyManagedProject: {
		id: 'admin-pages-priority-schemes.priority-scheme-modal.project-picker.project-picker-content.company-managed-project',
		defaultMessage: 'Company-managed project',
		description:
			'The type of Jira project where the two choices available are either company-managed or team-managed',
	},
	teamManagedProject: {
		id: 'admin-pages-priority-schemes.priority-scheme-modal.project-picker.project-picker-content.team-managed-project',
		defaultMessage: 'Team-managed project',
		description:
			'The type of Jira project where the two choices available are either company-managed or team-managed',
	},
});
